import { snakePhp, snakePhp2, snakeAxios, snakeAxios2 } from "./ApiService";

export const VedikaService= {
    daftarPasien(data){
        return snakeAxios.get(snakePhp +'transaksi/vedika/get-daftar-pasien?'+data);
    },
    dokumenVedika(data){
        return snakeAxios.get(snakePhp +'transaksi/vedika/get-dokument-vedika?'+data);
    },
    daftarAntrianVedika(data){
        return snakeAxios.get(snakePhp +'transaksi/dokter/get-daftar-antrian-vedika-bpjs?'+data);
    },
    getApd(data){
        return snakeAxios.get(snakePhp +'transaksi/rekam-medis/get-apd-vedika/'+data);
    },
    getOrderLabNew(data){
        return snakeAxios.get(snakePhp +`transaksi/laporan/get-order-lab-vedika?${data}`);
    },
    getRiwayatRadiologi(data){
        // return snakeAxios.get(snakePhp +`transaksi/lab-radiologi/get-riwayat-rad?${data}`);
        return snakeAxios.get(snakePhp +`transaksi/lab-radiologi/get-riwayat-rad-vedika?${data}`);
    },
    getHasilRadiologi(data,accession_num){
        return snakeAxios.get(snakePhp +`transaksi/lab-radiologi/get-hasil-rad?noorder=${data}&accession_num=${accession_num}`);
    },
    getAccNumberRadiologi(data){
        return snakeAxios.get(snakePhp +`transaksi/dokter/get-acc-number-radiologi?${data}`);
    },
    getResepDokter(data){
        return snakeAxios.get(snakePhp +`transaksi/rekam-medis/get-resep-dokter?${data}`);
    },
    getDetailResepDokter(data){
        return snakeAxios.get(snakePhp +`transaksi/rekam-medis/get-resep-dokter-detail-list?${data}`);
    },
    getCppt(data){
        return snakeAxios.get(snakePhp +`transaksi/rekam-medis/get-cppt?${data}`);
    },
    getLabBedah(data){
        return snakeAxios.get(snakePhp +`transaksi/rekam-medis/get-lap-pasca-bedah?${data}`);
    },
    getResumeMedis(data){
        return snakeAxios.get(snakePhp +`transaksi/rekam-medis/get-resume-medis-inap-noreg?noregistrasifk=${data}`);
    },
    getKonsultasi(data){
        return snakeAxios.get(snakePhp +`transaksi/rekam-medis/get-order-konsul?${data}`);
    },
    getPengkajianSekarang(data){
        return snakeAxios.get(snakePhp +`transaksi/rekam-medis/get-pengkajian-awal?${data}`);
    },
    getPengkajianTerdahulu(data){
        return snakeAxios.get(snakePhp +`transaksi/rekam-medis/get-riwayat?${data}`);
    },
    getPengkajianPerawat(data){
        return snakeAxios.get(snakePhp +`transaksi/rekam-medis/get-pengkajianpasien/${data}`);
    },
    getDiagnosisiIcd10(data){
        return snakeAxios.get(snakePhp +`transaksi/pasien/get-diagnosapasienbynoreg?${data}`);
    },
    getDiagnosisiIcd9(data){
        return snakeAxios.get(snakePhp +`transaksi/pasien/get-diagnosapasienbynoregicd9?${data}`);
    },
    getDiagnosis(data){
        return snakeAxios.get(snakePhp +`transaksi/pasien/get-diagnosapasienbynoreg-vedika?${data}`);
    },
    getAsesmenGizi(data){
        return snakeAxios.get(snakePhp +`transaksi/rekam-medis/get-asesmen-gizi-awal?${data}`);
    },
    getDetailTagihan(data){
        return snakeAxios.get(snakePhp +`transaksi/tatarekening/detail-tagihan/${data.noregistrasi}?jenisdata=layanan&idruangan=${data.ruangan}`);
    },
    getDetailTagihan2(data){
        return snakeAxios.get(snakePhp +`transaksi/tatarekening/cetak-detail-tagihan-vedika/${data.noregistrasi}`);
    },
    getHasilLab(data){
        return snakeAxios.get(snakePhp +`transaksi/lab-radiologi/get-hasil-lab?noorder=${data}`);
    },
    getDiagnosis2(data){
        return snakeAxios2.get(snakePhp2 +`get-diagnosa-vedika?${data}`);
    },
    getNilaiClaim(data){
        return snakeAxios2.get(snakePhp2 +`nilai-claim?${data}`);
    },
    getKlaimReport(data){
        return snakeAxios.get(snakePhp +`transaksi/vedika/get-klaim-report?${data}`);
    },
    getRekapKlaimReport(data){
        return snakeAxios.get(snakePhp +`transaksi/vedika/get-rekap-report?${data}`);
    },
    getSummaryList(data){
        return snakeAxios.get(snakePhp +`transaksi/rekam-medis/get-resume-medis-rev2/${data}`);
    },
    riwayatPakaiVentilator(data){
        return snakeAxios.get(snakePhp +`transaksi/emr/list-pakai-ventilator?${data}`);
    },
    getHasilTriase(data){
        return snakeAxios.get(snakePhp +`transaksi/generic/get-hasil-triase?noregistrasi=${data}`);
    },
    getHasilLabPA(data){
        return snakeAxios.get(snakePhp +`transaksi/lab-radiologi/get-hasil-lab-pa?noorder=${data}`);
    },
    getHasilResumeMedis(norec, nocm){
        return snakeAxios.get(snakePhp +`transaksi/rekam-medis/cetak-resume-medis?norec=${norec}&nocm=${nocm}`);
    }
}